<template>
  <div id="venue-add-update-dialog" class="custom-modal">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie v-if="loading == 'updateScreenLoading' && form == null" key="create-loading" />
        <el-row v-else key="content-loading">
          <el-row :gutter="10">
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("onsiteUtilities.controlPoints.vanueAddUpdate.title") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("onsiteUtilities.controlPoints.vanueAddUpdate.titleMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input v-model="form.title"></el-input>
                <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
              </div>
            </el-col>

            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("onsiteUtilities.controlPoints.vanueAddUpdate.controllerType") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("onsiteUtilities.controlPoints.vanueAddUpdate.controllerTypeMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-select v-model="form.controlPointType" v-if="getEnums" @change="changerType">
                  <el-option v-for="(type, index) in getEnums.find(x => x.title == 'ControlPointType').enums" :label="type.displayName" :value="type.key" :key="index + 'type'" :disabled="type.key == 1"></el-option>
                </el-select>
                <span class="error">{{ $errorMessage("controlPointType", validationErrors) }}</span>
              </div>
            </el-col>

            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("onsiteUtilities.controlPoints.vanueAddUpdate.controlType") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("onsiteUtilities.controlPoints.vanueAddUpdate.controlTypeMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-select v-model="form.type" v-if="getEnums" @change="changerControlType">
                  <template v-for="(type, index) in getEnums.find(x => x.title == 'AccessType').enums">
                    <el-option :label="type.displayName" v-if="type.key != 3" :value="type.key" :key="index + 'accesstype'"></el-option>
                  </template>
                </el-select>
                <span class="error">{{ $errorMessage("type", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24" v-if="form.type == 2">
              <div class="custom-groups-list mt-2">
                <div class="custom-groups-list-item" v-for="item in $store.state.groups.items" :key="item.id + '-tag-group-id'">
                  <div class="custom-groups-list-item-head" @click="item.show = !item.show">
                    <div class="custom-groups-list-item-head-title">
                      <span>
                        <i class="fas fa-square mr-2" :style="'color:' + item.color"></i>
                        {{ item.title }}
                      </span>
                      <span class="counter-badge" v-if="item.tags.filter(x => form.tags.some(y => y == x.id)).length > 0 ? true : false">{{ item.tags.filter(x => form.tags.some(y => y == x.id)).length }}</span>

                      <i class="fas fa-chevron-down" :class="{ active: item.show }"></i>
                    </div>
                    <el-button size="mini" type="primary" icon="fas fa-check" round @click.stop="selectAll(item.tags)">{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.selectAll") }}</el-button>
                  </div>
                  <transition name="el-zoom-in-top" mode="out-in">
                    <div class="custom-groups-list-item-tags" v-if="item.show">
                      <div class="customg-group-tag-item" v-for="tagItem in item.tags" :key="tagItem.id" @click="toggleTag(tagItem.id)" :class="{ active: form.tags.some(x => x == tagItem.id) }">
                        <div class="customg-group-tag-item-title">
                          <div class="tag-color-circle" :style="{ backgroundColor: tagItem.color }"></div>
                          <span>
                            {{ tagItem.title }}
                          </span>
                        </div>

                        <i class="fas fa-check"></i>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
              <!-- <el-collapse accordion class="tagfilter-collapse">
                <el-collapse-item v-for="group in $store.state.groups.items" :key="group.id + 'group-item'">
                  <template slot="title" v-if="group">
                    <div class="tagfilter-title">
                      <i class="fas fa-square" :style="{ color: group.color }"></i>
                      {{ group.title }}
                      <span v-if="group.tags.length > 0 && form.tags.length > 0">{{ group.tags.filter(x => form.tags.some(y => x.id === y)).length }}</span>
                    </div>
                  </template>
                  <div class="group-tags-container">
                    <template v-if="group.tags.length > 0">
                      <div class="tag-item" :class="{ active: form.tags.some(x => x == tag.id) ? true : false }" v-for="(tag, index) in group.tags" :key="index + 'tagitem'" @click="tagAdd(tag.id)">
                        <i class="fas fa-circle" :style="{ color: tag.color }"></i>
                        <span>{{ tag.title }}</span>
                        <b><i class="fas fa-check"></i></b>
                      </div>
                    </template>
                    <el-alert :closable="false" v-else type="info" class="w-100" :show-icon="true">{{ $t("onsiteUtilities.controlPoints.vanueAddUpdate.message1") }}</el-alert>
                  </div>
                </el-collapse-item>
              </el-collapse> -->
            </el-col>

            <el-col :span="24" v-if="form.type == 3">
              <div class="selection-item-container">
                <div class="item" v-for="subevent in $store.state.subevents.items" :class="{ active: form.subEventIds.some(x => x == subevent.id) }" :key="subevent.id + 'subevent'" @click="subEventAdd(subevent.id)">
                  {{ subevent.title }}
                  <i :class="form.subEventIds.length == 0 ? 'el-icon-check' : form.subEventIds.length > 0 && form.subEventIds.some(x => x.includes(subevent.id)) ? 'el-icon-check' : 'el-icon-error'"></i>
                </div>
              </div>
            </el-col>

            <el-col :span="24" class="mt-3" v-if="form.controlPointType == 2">
              <el-row>
                <el-col :span="24" class="live-control-area">
                  <div class="selected-only-live-channel">
                    <div class="live-info-title">{{ $t("onsiteUtilities.controlPoints.vanueAddUpdate.message2") }}</div>
                    <el-switch @change="changerSessionSwitch" v-model="form.enableRestrictionsForSessions"></el-switch>
                  </div>
                  <el-collapse-transition key="live-sessions">
                    <div class="selection-item-container pb-3" v-show="form.enableRestrictionsForSessions">
                      <div class="item" :class="(form.availableSessionIds.some(x => x == live.id) ? 'active ' : '') + ($store.state.venues.items.some(x => x.availableSessionIds.some(y => y == live.id) && x.id != form.id) ? 'passive' : '')" v-for="live in $store.state.livesessions.items" :key="live.id + 'livesession'" @click="liveAdd(live.id)">
                        {{ live.title }}
                        <i class="el-icon-check" v-if="!$store.state.venues.items.some(x => x.availableSessionIds.some(y => y == live.id) && x.id != form.id)"></i>
                        <template v-else>
                          <el-tooltip :content="$t('onsiteUtilities.controlPoints.vanueAddUpdate.assignedCheckpoint')" placement="top">
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </template>
                      </div>
                    </div>
                  </el-collapse-transition>
                </el-col>

                <el-col :span="24" class="live-control-area mt-1">
                  <div class="selected-only-live-channel">
                    <div class="live-info-title">{{ $t("onsiteUtilities.controlPoints.vanueAddUpdate.message3") }}</div>
                    <el-switch @change="changerNetworkingSwitch" v-model="form.enableRestrictionsForNetworkingAreas"></el-switch>
                  </div>
                  <el-collapse-transition key="live-sessions-2">
                    <div class="selection-item-container pb-3" v-show="form.enableRestrictionsForNetworkingAreas">
                      <div class="item" :class="(form.availableNetworkingAreaIds.some(x => x == network.id) ? 'active ' : '') + ($store.state.venues.items.some(x => x.availableNetworkingAreaIds.some(y => y == network.id) && x.id != form.id) ? 'passive' : '')" v-for="network in $store.state.networking.items" :key="network.id + 'networkingarea'" @click="networkAdd(network.id)">
                        {{ network.title }}
                        <i class="el-icon-check" v-if="!$store.state.venues.items.some(x => x.availableNetworkingAreaIds.some(y => y == network.id) && x.id != form.id)"></i>
                        <template v-else>
                          <el-tooltip :content="$t('onsiteUtilities.controlPoints.vanueAddUpdate.assignedCheckpoint')" placement="top">
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </template>
                      </div>
                    </div>
                  </el-collapse-transition>
                </el-col>
              </el-row>
            </el-col>

            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("onsiteUtilities.controlPoints.vanueAddUpdate.note") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("onsiteUtilities.controlPoints.vanueAddUpdate.noteMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <quill-editor :options="editorOption" ref="myQuillEditor" @ready="onEditorReady($event)" v-model="form.details" />
                <span class="error">{{ $errorMessage("details", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10" v-if="form">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="settingsDock = !settingsDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("onsiteUtilities.controlPoints.vanueAddUpdate.settings") }}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span class="text-danger" v-if="validationErrors.some(x => x.key.includes('location')) || validationErrors.some(x => x.key.includes('socialMedia'))">{{ validationErrors.some(x => x.key.includes("location")) ? validationErrors.filter(x => x.key.includes("location")).length + " hatalı alan bulunmaktadır." : "" }}</span>
                    <span>{{ $t("onsiteUtilities.controlPoints.vanueAddUpdate.settingsMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="settingsDock">
                    <div class="custom-set-container" :class="form.isActive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("onsiteUtilities.controlPoints.vanueAddUpdate.view") }}
                            <!-- <el-tooltip content="Content" placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("onsiteUtilities.controlPoints.vanueAddUpdate.viewMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.isActive"></el-switch>
                      </div>
                    </div>

                    <div class="custom-set-container" :class="form.enableTimeRestriction ? 'sactive' : ''">
                      <div class="custom-set-inner">
                        <i :class="form.enableTimeRestriction ? 'fas fa-clock' : 'fas fa-clock'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("onsiteUtilities.controlPoints.vanueAddUpdate.timeRestriction") }}
                            <!-- <el-tooltip content="Content" placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("onsiteUtilities.controlPoints.vanueAddUpdate.timeRestrictionMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.enableTimeRestriction"></el-switch>
                      </div>
                      <div class="custom-set-actions fcenter mt-3" v-show="form.enableTimeRestriction">
                        <el-row :gutter="20" class="d-flex" style="width: 100%;">
                          <el-col :span="12">
                            <div class="registerform-input-container">
                              <div class="title">
                                <label>{{ $t("onsiteUtilities.controlPoints.vanueAddUpdate.startTime") }}</label>
                                <!-- <el-tooltip content="Content" placement="bottom">
                                  <i class="el-icon-info"></i>
                                </el-tooltip> -->
                              </div>
                              <el-time-select style="width:100%;" v-model="form.startTime" :placeholder="$t('onsiteUtilities.controlPoints.vanueAddUpdate.specifyTime')" :picker-options="{ start: '00:00', step: '00:05', end: '23:59' }"></el-time-select>
                              <span class="error">{{ $errorMessage("startTime", validationErrors) }}</span>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="registerform-input-container">
                              <div class="title">
                                <label>{{ $t("onsiteUtilities.controlPoints.vanueAddUpdate.endTime") }}</label>
                                <!-- <el-tooltip content="Content" placement="bottom">
                                  <i class="el-icon-info"></i>
                                </el-tooltip> -->
                              </div>
                              <el-time-select style="width:100%;" v-model="form.endTime" :picker-options="{ start: '00:00', step: '00:05', end: '23:59' }" :placeholder="$t('onsiteUtilities.controlPoints.vanueAddUpdate.specifyTime')"></el-time-select>
                              <span class="error">{{ $errorMessage("endTime", validationErrors) }}</span>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
        </el-row>
      </transition>
    </div>
    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading' && form != null">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("onsiteUtilities.controlPoints.vanueAddUpdate.close") }}</el-button>
        <template v-if="form.id != null">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash">{{ $t("onsiteUtilities.controlPoints.vanueAddUpdate.delete") }}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'saveLoading'" :disabled="loading == 'saveLoading'" @click="save">{{ $t("onsiteUtilities.controlPoints.vanueAddUpdate.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ItemInfo from "./ItemInfo";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import moment from "moment";

import { quillEditor } from "vue-quill-editor";
export default {
  components: { ItemInfo, quillEditor },
  name: "SubEventAddUpdate",
  props: ["data", "id"],
  beforeMount() {
    this.type != null ? (this.form.type = parseInt(this.type)) : 1;
  },
  mounted() {
    this.$store.dispatch("getVenues");
  },
  data() {
    return {
      form: null,
      settingsDock: false,
      editorOption: {
        modules: {
          toolbar: [["bold", "italic", "underline", "strike"], [{ color: [] }], ["clean"]],
          syntax: {
            highlight: text => hljs.highlightAuto(text).value
          }
        }
      },

      logoPercent: 0,
      axios,
      loading: false,
      timeout: null,
      validationErrors: [],
      showInfo: false,
      moment
    };
  },
  methods: {
    toggleTag(id) {
      var fIndex = this.form.tags.findIndex(x => x == id);
      if (fIndex != -1) {
        this.form.tags.splice(fIndex, 1);
      } else {
        this.form.tags.push(id);
      }
    },
    selectAll(tags) {
      tags.forEach(x => {
        var fIndex = this.form.tags.findIndex(y => y == x.id);
        if (fIndex == -1) {
          this.form.tags.push(x.id);
        }
      });
    },
    onEditorReady(editor) {
      editor.root.setAttribute("data-placeholder", this.$t("enterText"));
      editor.getModule("toolbar").addHandler("image", () => {
        this.selectLocalImage(editor);
      });
    },
    networkAdd(id) {
      if (this.$store.state.venues.items.some(x => x.availableNetworkingAreaIds.some(y => y == id) && x.id != this.form.id)) {
        return;
      }
      if (this.form.availableNetworkingAreaIds.some(x => x == id)) {
        var cIndex = this.form.availableNetworkingAreaIds.findIndex(x => x == id);
        this.form.availableNetworkingAreaIds.splice(cIndex, 1);
      } else {
        this.form.availableNetworkingAreaIds.push(id);
      }
    },
    liveAdd(id) {
      if (this.$store.state.venues.items.some(x => x.availableSessionIds.some(y => y == id) && x.id != this.form.id)) {
        return;
      }
      if (this.form.availableSessionIds.some(x => x == id)) {
        var cIndex = this.form.availableSessionIds.findIndex(x => x == id);
        this.form.availableSessionIds.splice(cIndex, 1);
      } else {
        this.form.availableSessionIds.push(id);
      }
    },
    subEventAdd(id) {
      if (this.form.subEventIds.some(x => x == id)) {
        var cIndex = this.form.subEventIds.findIndex(x => x == id);
        this.form.subEventIds.splice(cIndex, 1);
      } else {
        if (this.form.subEventIds.length == 0) {
          this.form.subEventIds.push(id);
        }
      }
    },
    tagAdd(id) {
      if (this.form.tags.some(x => x == id)) {
        var cIndex = this.form.tags.findIndex(x => x == id);
        this.form.tags.splice(cIndex, 1);
      } else {
        this.form.tags.push(id);
      }
    },
    selectLocalImage() {
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.click();
      input.onchange = () => {
        const file = input.files[0];
        if (/^image\//.test(file.type)) {
          this.saveToServer(file);
        } else {
          console.warn("You could only upload images.");
        }
      };
    },
    saveToServer(file) {
      const fd = new FormData();
      fd.append("image", file);
      const xhr = new XMLHttpRequest();
      xhr.open("POST", axios.defaults.baseURL + "event/uploadImage?uploadType=html&language=" + this.$i18n.locale, true);
      xhr.setRequestHeader("Authorization", "Bearer " + localStorage.getItem("token"));

      xhr.onload = () => {
        if (xhr.status === 200) {
          const body = JSON.parse(xhr.responseText);
          if (body.alert.hasError == false) {
            const url = body.data.item.url;
            this.insertToEditor(url);
          } else {
            this.$message.error(body.alert.message);
          }
        }
      };

      xhr.send(fd);
    },
    insertToEditor(url) {
      const range = this.$refs.myQuillEditor.quill.getSelection();
      this.$refs.myQuillEditor.quill.insertEmbed(range.index, "image", `${url}`);
    },
    deleteItem() {
      this.$emit("deleteMe", this.form.id);
      this.$emit("closeDialog");
    },
    async save() {
      this.loading = "saveLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await axios.post("controlpoint/addorupdate", {
          ...this.form
        });
        this.validationErrors = res.data.validationErrors;
        if (res.data.alert.hasError) {
          this.$message.error(res.data.alert.message);
        } else {
          this.$message.success(res.data.alert.message);
          this.form = res.data.data.item;
          await this.$store.dispatch("getVenues");
        }
        this.loading = false;
      }, 500);
    },
    changerType() {
      this.form.subEventIds = [];
      this.form.tags = [];
    },
    changerControlType() {
      this.form.enableRestrictionsForNetworkingAreas = false;
      this.form.enableRestrictionsForSessions = false;
      this.form.availableSessionIds = [];
      this.form.availableNetworkingAreaIds = [];
      this.form.subEventIds = [];
      this.form.tags = [];
    },
    changerSessionSwitch() {
      this.form.availableSessionIds = [];
    },
    changerNetworkingSwitch() {
      this.form.availableNetworkingAreaIds = [];
    }
  },

  computed: {
    getEnums() {
      return this.$store.getters.getEnums;
    }
  },
  async created() {
    this.loading = "updateScreenLoading";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      if (this.id != null) {
        var res = await this.$store.dispatch("getVenue", this.id);
        this.form = res.data.data.item;
        await Promise.all([this.$store.dispatch("getGroups"), this.$store.dispatch("getNetworkings"), this.$store.dispatch("getSubEvents"), this.$store.dispatch("getLiveSessions")]);
      } else {
        this.form = {
          id: null,
          title: null,
          details: null,
          type: null,
          controlPointType: null,
          isActive: false,
          enableTimeRestriction: false,
          enableRestrictionsForNetworkingAreas: false,
          enableRestrictionsForSessions: false,
          tags: [],
          availableSessionIds: [],
          availableNetworkingAreaIds: [],
          subEventIds: []
        };
      }
      this.loading = false;
    }, 500);
  },
  async mounted() {}
};
</script>

<style lang="less" scoped>
.registerform-input-container {
  .tag-container {
    gap: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .badge-list {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    .badger {
      border-radius: 8px;
      background-color: #f3f3f3;
      height: 20px;
      padding: 10px;
    }
  }
  .title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    label {
      font-weight: bold;
      color: black;
      margin-bottom: 0;
    }
    .title-container {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      align-items: center;
    }
  }
  display: flex;
  flex-direction: column;
  .el-input-number {
    width: 100%;
  }
}
.mage-maker {
  width: 100%;
  position: relative;
  border: 1px dashed #ccc;
  height: 250px;
  background-size: contain !important;
  background-position: center center !important;
  border-radius: 5px;
  background-repeat: no-repeat !important;
  .avatar-uploader {
    opacity: 0;
    transition: all 1s;
    &:hover {
      opacity: 1 !important;
    }
    & > .el-upload {
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 250px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.group-btn-container {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  justify-content: flex-end;
  align-items: center;

  .el-button {
    padding: 4px;
    margin-left: 0;
  }
  i.el-icon-info {
    font-size: 24px;
  }
}
.model-base-small {
  min-width: 500px;
}
.switch-btn-container {
  display: flex;
  .el-button {
    flex-grow: 1;
  }
}
.selection-item-container {
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
  .item {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    border-radius: 8px;
    border: 0.5px solid #d6d9d9;
    align-items: center;
    padding: 12px;
    font-weight: bold;
    border-radius: 8px;
    position: relative;
    color: #292f3b;
    transition: all 0.5s;
    .title {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      align-items: center;
    }
    cursor: pointer;
    i {
      position: absolute;
      color: #eaeaea;
      font-weight: bold;
      right: 1rem;
      font-size: 16px;
    }
    &.active {
      i {
        position: absolute;
        display: block;
        font-weight: bold;
      }
      color: white;
      background-color: #06658c;
    }

    &.passive {
      color: #c2c2c2;
      cursor: default;
      i {
        position: absolute;
        display: block;
        color: #ff6565;
      }
    }
  }
}
.tags-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 1rem;
  .el-alert {
    grid-column: span 4;
  }
  .item {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    border: 2px solid #eaeaea;
    height: 48px;
    align-items: center;
    padding: 0.5rem;
    font-weight: bold;
    border-radius: 8px;
    position: relative;
    transition: all 0.5s;
    .title {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      align-items: center;
    }
    cursor: pointer;
    i {
      position: absolute;
      display: none;
      color: white;
      font-weight: bold;
    }
    &.active {
      i {
        position: absolute;
        right: 1rem;
        display: block;
        font-weight: bold;
      }
      color: white;
      border: 2px solid #06658c;
      background-color: #06658c;
    }
  }
}
.circle-color-pick {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  flex-shrink: 0;
}
.live-control-area {
  display: flex;
  gap: 1rem;
  flex-direction: column;
  .selected-only-live-channel {
    padding: 12px;
    background-color: #f1f1f1;
    border-radius: 8px;
    font-weight: bold;
    margin-bottom: 0.5rem;
    gap: 0.5rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .live-info-title {
      font-size: 15px;
      color: #292f3b;
      font-weight: 600;
    }
  }
  .container-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #eaeaea;
    padding: 0.7rem;
    height: 48px;
    font-weight: bold;
  }
  .live-session-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.3rem;
    font-weight: bold;
    &.passive {
      color: #ccc;
      .el-checkbox {
        display: none;
      }
      .info-icons {
        display: block;
      }
    }
    .info-icons {
      display: none;
    }
  }
}
</style>
<style lang="less">
.collapse-container {
  .el-collapse-item {
    & > div {
      .el-collapse-item__header {
        .collapse-title {
          display: flex;
          gap: 0.5rem;
          align-items: center;
        }
        padding: 1rem;
        background-color: #eaeaea !important;
        i {
          font-weight: bold;
          right: 1rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VenueAddUpdate.vue